import script from "./home.vue?vue&type=script&setup=true&lang=js"
export * from "./home.vue?vue&type=script&setup=true&lang=js"

import "./home.css?vue&type=style&index=0&lang=css"

const __exports__ = script;

export default __exports__